module.exports = __webpack_public_path__ + "media/38.1740f4da.wav";